// ---------------------------------------------------------------------------------------------
// Outbound messaging: email and WhatsApp
//
// Both channels share this vocabulary. The delivery lifecycle, the retry accounting and the
// idempotency rule are the same for each, and an administrator reads one history, not two.
// ---------------------------------------------------------------------------------------------
export const OUTBOUND_MESSAGE_STATUS = {
    QUEUED: 'QUEUED',
    SENDING: 'SENDING',
    SENT: 'SENT',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED',
};
export const OUTBOUND_MESSAGE_STATUS_LABELS = {
    QUEUED: 'Queued',
    SENDING: 'Sending',
    SENT: 'Sent',
    FAILED: 'Failed',
    SKIPPED: 'Not sent',
};
/** Statuses that will not change again without a new attempt. */
export const TERMINAL_OUTBOUND_STATUSES = [
    'SENT',
    'FAILED',
    'SKIPPED',
];
export const EMAIL_ENCRYPTION = {
    NONE: 'NONE',
    STARTTLS: 'STARTTLS',
    TLS: 'TLS',
};
export const EMAIL_ENCRYPTION_LABELS = {
    NONE: 'None (not recommended)',
    STARTTLS: 'STARTTLS (usually port 587)',
    TLS: 'TLS / SSL (usually port 465)',
};
/**
 * The transactional messages the system sends.
 *
 * Every one of these is a reaction to something that happened on an account. There is no
 * campaign, list or broadcast template here, and adding one would need a different mechanism —
 * consent tracking and an unsubscribe path that transactional mail does not have.
 */
export const MESSAGE_TEMPLATE = {
    TASK_ASSIGNED: 'TASK_ASSIGNED',
    REVIEW_REQUESTED: 'REVIEW_REQUESTED',
    REVIEW_REJECTED: 'REVIEW_REJECTED',
    TICKET_CREATED: 'TICKET_CREATED',
    TICKET_REPLY: 'TICKET_REPLY',
    SLA_AT_RISK: 'SLA_AT_RISK',
    CLIENT_APPROVAL_REQUESTED: 'CLIENT_APPROVAL_REQUESTED',
    CONTRACT_EXPIRING: 'CONTRACT_EXPIRING',
    INVOICE_ISSUED: 'INVOICE_ISSUED',
    RELEASE_NOTE_PUBLISHED: 'RELEASE_NOTE_PUBLISHED',
    /** Sent only by the "send a test" button on the settings screen. */
    TEST: 'TEST',
};
export const MESSAGE_TEMPLATE_LABELS = {
    TASK_ASSIGNED: 'Task assigned',
    REVIEW_REQUESTED: 'Review requested',
    REVIEW_REJECTED: 'Review rejected',
    TICKET_CREATED: 'Ticket created',
    TICKET_REPLY: 'Ticket reply',
    SLA_AT_RISK: 'SLA at risk',
    CLIENT_APPROVAL_REQUESTED: 'Client approval requested',
    CONTRACT_EXPIRING: 'Contract expiring',
    INVOICE_ISSUED: 'Invoice issued',
    RELEASE_NOTE_PUBLISHED: 'Release note published',
    TEST: 'Test message',
};
/**
 * Which notification type produces which template.
 *
 * A notification type that is not listed has no email or WhatsApp template, so it stays in-app
 * only — the mapping is the allow-list, not a default.
 */
export const NOTIFICATION_TEMPLATE_MAP = {
    TASK_ASSIGNED: 'TASK_ASSIGNED',
    TASK_REVIEW_REQUESTED: 'REVIEW_REQUESTED',
    TASK_REVIEW_REJECTED: 'REVIEW_REJECTED',
    TICKET_NEW: 'TICKET_CREATED',
    TICKET_REPLY: 'TICKET_REPLY',
    SLA_WARNING: 'SLA_AT_RISK',
    SLA_BREACH: 'SLA_AT_RISK',
    APPROVAL_REQUESTED: 'CLIENT_APPROVAL_REQUESTED',
    CONTRACT_EXPIRY: 'CONTRACT_EXPIRING',
    CONTRACT_RENEWAL: 'CONTRACT_EXPIRING',
    // Deliberately absent: TASK_DUE_SOON, TASK_OVERDUE, APPROVAL_DECIDED, SUPPORT_HOURS_LOW and
    // CHANGE_REQUEST_STATUS stay in-app. They fire often enough that mailing them would train
    // people to ignore the mail.
};
export function templateForNotification(type) {
    return NOTIFICATION_TEMPLATE_MAP[type] ?? null;
}
/** Templates that need an approved WhatsApp template name before they can be sent. */
export const WHATSAPP_TEMPLATES = [
    'TASK_ASSIGNED',
    'TICKET_REPLY',
    'SLA_AT_RISK',
    'CLIENT_APPROVAL_REQUESTED',
    'CONTRACT_EXPIRING',
    'INVOICE_ISSUED',
    'RELEASE_NOTE_PUBLISHED',
    'TEST',
];
//# sourceMappingURL=messaging.js.map